<template>
  <div class="call-controls">
    <v-btn :color="isAudioEnabled ? 'primary' : 'error'" icon size="large" @click="$emit('toggle-audio')">
      <v-icon>{{ isAudioEnabled ? "mdi-microphone" : "mdi-microphone-off" }}</v-icon>
    </v-btn>

    <v-btn :color="isVideoEnabled ? 'primary' : 'error'" icon size="large" @click="$emit('toggle-video')">
      <v-icon>{{ isVideoEnabled ? "mdi-video" : "mdi-video-off" }}</v-icon>
    </v-btn>

    <!-- Recording button hidden per user request -->
    <!--
    <v-btn
      :color="isRecording ? 'error' : 'primary'"
      :loading="recordingStatus === 'paused'"
      icon
      size="large"
      @click="$emit(isRecording ? 'stop-recording' : 'start-recording')"
    >
      <v-icon>{{ isRecording ? "mdi-stop-circle" : "mdi-record-circle" }}</v-icon>
    </v-btn>
    -->

    <v-btn color="error" icon size="x-large" @click="$emit('end-call')">
      <v-icon>mdi-phone-hangup</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  isAudioEnabled: boolean;
  isVideoEnabled: boolean;
  // Recording props hidden per user request
  // isRecording?: boolean;
  // recordingStatus?: "idle" | "recording" | "paused";
}

defineProps<Props>();

defineEmits<{
  "toggle-audio": [];
  "toggle-video": [];
  "end-call": [];
  // Recording emits hidden per user request
  // "start-recording": [];
  // "stop-recording": [];
  // "pause-recording": [];
  // "resume-recording": [];
}>();
</script>

<style lang="scss" scoped>
.call-controls {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
}
</style>
